
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content: 'Explore the full lyrics of Stotra "Shri Ganeshay Namaa" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: 'Explore the full lyrics of Stotra "Shri Ganeshay Namaa" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Shri Ganeshay Namaa, Ganpati Atharvashirsha, Ganpati Atharvashirsha English, Ganpati Atharvashirsha marathi, Ganesh Atharva Shirsha stotra'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Shri Ganeshay Namaa, Ganpati Atharvashirsha, Ganapati Atharvashirsha mantra, Ganpati Atharvashirsha Marathi, Ganpati Atharvashirsha English, Lord Ganesha prayer, Ganesh Atharva Shirsha stotra, Atharvashirsha Ganesh path, Spiritual chants to Lord Ganesha, ganpati atharvashirsha lyrics, गणपति अथर्वशीर्ष पाठ, गणपति अथर्वशीर्ष, गणपती अथर्वशीर्ष स्तोत्र मराठी lyrics' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/stotra/athrvashirsha.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/stotra/athrvashirsha.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Shri Ganeshay Namaa | Ganpati Athrvashirsha - श्री गणेशाय नम:(गणपति अथर्वशीर्ष)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
      
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/stotra/athrvashirsha"
        },
        "headline": "Shri Ganeshay Namaa - श्री गणेशाय नम:(गणपति अथर्वशीर्ष)",
        "name" : "Shri Ganeshay Namaa - Ganpati Athrvashirsha",
        "description": "Explore the full lyrics of stotra 'Shri Ganeshay Namaa' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/stotra/athrvashirsha.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
    }
  